export default __webpack_public_path__ + "static/media/image 378.57a35dbf076e1c49735d08a6f6effd9e.svg";